export default "__VITE_ASSET__pjQkU$B4__"